module.exports = __webpack_public_path__ + "static/nephrite-jade-gemstone-slabs-4ca939e9432c707a68fd4f75a5dba7f4.jpg";